import { Breadcrumbs as MuiBreadcrumbs, Stack, styled, Typography } from '@mui/joy';
import { Link } from 'react-router-dom';

const StyledLink = styled(Link)(({ theme }) => ({
  color: theme.vars.palette['hyperlink']['text'],
  textUnderlineOffset: '0.15em',
}));

const Breadcrumbs = ({
  currentPage,
  parentPage,
}: {
  currentPage?: string;
  parentPage?: { label: string; path: string };
}) => {
  return (
    <Stack
      sx={{
        py: '12px',
        px: 3,
        bgcolor: (theme) => theme.palette.background.surface,
        borderBottom: (theme) => `1px solid ${theme.palette.primary.outlinedBorder}`,
      }}
    >
      <MuiBreadcrumbs separator='/' sx={{ p: 0, ol: { flexWrap: 'nowrap', overflowX: 'auto' } }}>
        <Typography level='body-md' sx={{ textWrap: 'nowrap' }}>
          Diligence tools
        </Typography>
        {currentPage || parentPage ? (
          <StyledLink to='/project-screener' sx={{ textWrap: 'nowrap' }}>
            Project screener
          </StyledLink>
        ) : (
          <Typography level='body-md' sx={{ textWrap: 'nowrap' }}>
            Project screener
          </Typography>
        )}
        {parentPage && (
          <StyledLink to={parentPage.path} sx={{ textWrap: 'nowrap' }}>
            {parentPage.label}
          </StyledLink>
        )}
        {currentPage && (
          <Typography level='body-md' sx={{ textWrap: 'nowrap' }}>
            {currentPage}
          </Typography>
        )}
      </MuiBreadcrumbs>
    </Stack>
  );
};

export { Breadcrumbs };
